const $ = jQuery.noConflict()

class Slider {
    constructor(selector, args = {}) {
        this.selector = selector
        this.args = args
    }

    getDefaultSlickSettings() {
        return {
            dots: false,
            arrows: true,
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            pauseOnHover: false,
            speed: 600,
        }
    }

    /**
     * Override our default slick settings with args provided to the class.
     */
    getSlickSettings() {
        return Object.assign({}, this.getDefaultSlickSettings(), this.args)
    }

    init() {
        if ($(this.selector).length > 0 && !$(this.selector).hasClass('slick-initialized')) {
            let settings = this.getSlickSettings()

            $(this.selector).slick(settings)
        }
    }

    resize() {
        if ($(this.selector).length > 0 && !$(this.selector).hasClass('slick-initialized')) {
            $(this.selector).slick('resize')
        }
    }
}

const SimpleSlider = new Slider('.gallery-slider__slider')
const TestimonialSlider = new Slider('.testimonial-slider')

const HeroSlider = new Slider('.block-hero__slider', {
    dots: true,
    arrows: false,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    pauseOnHover: false,
    appendDots: $('.block-hero__wrapper'),
    autoplay: true,
    autoplaySpeed: 2000,
})
const InfobannerSlider = new Slider('.block-hero__info-banner-container', {
    dots: false,
    arrows: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    pauseOnHover: false,
    autoplay: true,
    autoplaySpeed: 4000,
})
const FluidSlider = new Slider('.gallery-slider__slider-fluid', {
    centerMode: true,
    variableWidth: true,
    dots: true,
    responsive: [
        {
            breakpoint: 1290,
            settings: {
                dots: false,
                centerMode: true,
                variableWidth: true,
            },
        },
    ],
})
const ImageLinkSliderSlickOnce = new Slider('.block-ils-slider__left', {
    slidesToShow: 1,
    centerMode: false,
    centerPadding: '0',
    asNavFor: '.block-ils-slider__right',
    infinite: false,
    arrows: false,
    touchMove: false,
    swipeToSlide: false,
    swipe: false,
    responsive: [
        {
            breakpoint: 1200,
            settings: 'unslick',
        },
    ],
})

const ImageLinkSliderSlickTwice = new Slider('.block-ils-slider__right', {
    slidesToShow: 3,
    slidesToScroll: 1,
    variableWidth: true,
    dots: true,
    infinite: false,
    touchMove: false,
    swipeToSlide: false,
    swipe: false,
    asNavFor: '.block-ils-slider__left',
    responsive: [
        {
            breakpoint: 1200,
            settings: 'unslick',
        },
    ],
})

const SectionsFroumsSingleSlider = new Slider('.sections-forums-single-hero__slider-wrapper', {
    dots: true,
    arrows: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    pauseOnHover: false,
    appendDots: $('.sections-forums-single-hero__slider'),
    autoplay: false,
    autoplaySpeed: 10000,
    speed: 1200,
    variableWidth: true,
    draggable: false
})


const ScrollingLogos = new Slider('.block-scrolling-logos__wrapper', {
    speed: 4000,
    autoplay: true,
    autoplaySpeed: 0,
    centerMode: true,
    cssEase: 'linear',
    slidesToShow: 1,
    draggable: false,
    focusOnSelect: false,
    pauseOnFocus: false,
    pauseOnHover: false,
    slidesToScroll: 1,
    variableWidth: true,
    infinite: true,
    initialSlide: 1,
    arrows: false,
    rtl: true,
})

const ScrollingDonors = new Slider('.block-scrolling-donors__wrapper', {
    speed: 4000,
    autoplay: true,
    autoplaySpeed: 0,
    centerMode: true,
    cssEase: 'linear',
    slidesToShow: 1,
    draggable: false,
    focusOnSelect: false,
    pauseOnFocus: false,
    pauseOnHover: false,
    slidesToScroll: 1,
    variableWidth: true,
    infinite: true,
    initialSlide: 1,
    arrows: false,
    rtl: true,
})

const EventCardsSlider = new Slider('.block-events__slider', {
	infinite: false,
	slidesToShow: 3,
	slidesToScroll: 3,
	autoplay: false,
	adaptiveHeight: true,
	responsive: [
		{
			breakpoint: 992,
			settings: {
			  slidesToShow: 2,
			  slidesToScroll: 2,
			},
		},
		{
		  breakpoint: 768,
		  settings: {
			slidesToShow: 1,
			slidesToScroll: 1,
		  },
		}
	],
})

export {
    Slider,
    HeroSlider,
    SimpleSlider,
    TestimonialSlider,
    FluidSlider,
    InfobannerSlider,
    ImageLinkSliderSlickOnce,
    ImageLinkSliderSlickTwice,
    SectionsFroumsSingleSlider,
    ScrollingLogos,
    ScrollingDonors,
	EventCardsSlider,
}
